
import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios';
import { RelOrderClaimVO } from '@/views/biz/order/vo/order.vo'

@Component
export default class InvoiceNumberForm extends Vue {
  @Prop() claimCd !: number;

  claim = {} as RelOrderClaimVO;

  // 저장
  save(): void {
    if(!this.claim.logisticsComp) {
      // 물류사를 입력하세요.
      return alert(this.$t('claim.a0007'));
    }

    if(!this.claim.returnInvcNo) {
      // 운송장번호를 입력하세요.
      return alert(this.$t('claim.a0007'));
    }


    // 저장하시겠습니까?
    if(confirm(this.$t('common.c0005').toString())) {
      axios.put(`/mypage/order/claim/${this.claimCd}`, this.claim)
      .then( r => {
        if(r.data) {
          // 운송장번호가 저장되었습니다.
          alert(this.$t('claim.a0007'));
        }
        
        this.$router.push({name: 'OrderClaimDetail', params: {claimType: 'return', orderCd: this.claim.orderCd.toString(), claimCd: this.claimCd.toString()}});
      });
    }
  }

  // 초기화
  created() {
    axios.get(`/mypage/order/claim/${this.claimCd}`)
    .then( r => {
      this.claim = r.data;
    });
  }

}
